module.exports = __webpack_public_path__ + "static/img/new-9.689d9f80.jpg";